
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LoggerService } from '../logger.service';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  public message: string
  public brokertype: string
  private corporateNameSource = new BehaviorSubject<any>(null);
  private corporateStatusSource = new BehaviorSubject<any>(null);
  private langTokensSource = new BehaviorSubject<any>(null)

  corporateName = this.corporateNameSource.asObservable();
  corporateStatus = this.corporateStatusSource.asObservable();
  langTokens = this.langTokensSource.asObservable()

  constructor(private logger: LoggerService,) { }



  setLangToken(data: any) {
    console.log({ data })
    this.langTokensSource.next(data)
  }



  setMessage(data) {
    this.message = data
  }

  getMessage() {
    return this.message
  }

  setCorporationName(name: string) {
    this.corporateNameSource.next(name);
  }


  setCorporateStatus(status: string) {
    this.corporateStatusSource.next(status)
  }


  setBroker(data) {
    this.brokertype = data
  }

  getBroker() {
    return this.brokertype
  }

}
